import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelecionarEmpresaRoutingModule } from './selecionar-empresa-routing.module';
import { SelecionarEmpresaComponent } from './selecionar-empresa.component';
import { AppConfigModule } from 'src/app/layout/config/app.config.module';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { HttpClientModule } from '@angular/common/http';
import { SelecionarEmpresaGuard } from './selecionar-empresa.guard';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from 'primeng/messages';

@NgModule({
    imports: [
        CommonModule,
        SelecionarEmpresaRoutingModule,
        AppConfigModule,
        HttpClientModule,
        TooltipModule,
        DividerModule,
        ButtonModule,
        TableModule,
        InputTextModule,
        ProgressSpinnerModule,
        MessagesModule
    ],
    declarations: [SelecionarEmpresaComponent],
    providers: [SelecionarEmpresaGuard]
})
export class SelecionarEmpresaModule { }
